export const actionTypes = {
    SELECT_MENU_ITEM: 'gatewayMenuItem/SELECT_MENU_ITEM'
};

export const gatewayType = {
    NETA21: 'NETA-21',
    DCP: 'DCP',
    EGW02: 'EGW-02',
    CASSIA: 'Cassia',
    ARUBA: 'Aruba',
    MACHSENSER: 'Machine Guardian',
    UNKNOWN: 'Unknown'
};

export const gatewayMenuItems = {
    REBOOT_GATEWAY: 'gatewayMenuItem/REBOOT_GATEWAY',
    UPDATE_FIRMWARE: 'gatewayMenuItem/UPDATE_FIRMWARE',
    REFRESH_NETA: 'gatewayMenuItem/REFRESH_NETA',
    DOWNLOAD_INSTALLATION_REPORT: 'gatewayMenuItem/DOWNLOAD_INSTALLATION_REPORT',
    DOWNLOAD_DIAGNOSTIC_REPORT: 'gatewayMenuItem/DOWNLOAD_DIAGNOSTIC_REPORT',
    ACTIVATE_REMOTE_CONNECTION: 'gatewayMenuItem/ACTIVATE_REMOTE_CONNECTION',
    DEACTIVATE_REMOTE_CONNECTION: 'gatewayMenuItem/DEACTIVATE_REMOTE_CONNECTION',
    DELETE_GATEWAY: 'gatewayMenuItem/DELETE_GATEWAY',
    EXPORT_MESSAGE_ARCHIVE: 'gatewayMenuItem/EXPORT_MESSAGE_ARCHIVE'
};

export const INSTALLATION_REPORT_NETA = 'InstallationReportNeta';

export const GATEWAY_STATUS_CLASS = {
    CONNECTED: 'connected',
    DISCONNECTED: 'disconnected',
    CONNECTED_WITH_WARNING: 'connected-with-warning',
};

